import { Remarkable } from "remarkable"
import SpinningLogoComponent from "../spinning-logo/spinning-logo.component"
import "./text-hero.component.css"
import { useLocation } from "react-router-dom"
import PixelComponent from "../pixel/pixel.component"
import SpacerComponent from "../spacer/spacer.component"

const TextHeroComponent = (props) => {
  const { Heading, Subheading, Copy, AddSpinningLogo, AddPixelAnimation } =
    props
  const md = new Remarkable()
  const { pathname } = useLocation()

  const normalizedPath = pathname.toLowerCase().replace(/\/+$/, "").trim()
  const isWorkRoute = ["/our-work"].includes(normalizedPath)
  const isWereCopy = Heading?.toLowerCase().indexOf("we're dagger") > -1

  return (
    <div className="dagger-text-hero-wrapper">
      <div className={`dagger-text-hero ${isWorkRoute ? "is-work-page" : ""}`}>
        <div className="dagger-text-left">
          <h1>
            {isWereCopy ? (
              <>
                We're
                <br />
                Dagger.
              </>
            ) : (
              Heading
            )}
          </h1>
          {Subheading && Copy && <h2>{Subheading}</h2>}
          {Subheading && !Copy && (
            <div className="dagger-text-hero-copy">{Subheading}</div>
          )}
        </div>
        {Copy && (
          <div
            className="dagger-text-hero-copy"
            dangerouslySetInnerHTML={{
              __html: md.render(Copy),
            }}
          ></div>
        )}
        {AddSpinningLogo && (
          <div className="dagger-text-hero-logo">
            <SpinningLogoComponent />
          </div>
        )}
      </div>
      {AddPixelAnimation && (
        <>
          <SpacerComponent size="Large" />
          <PixelComponent
            className="bottom-grid-right"
            anchor="bottom-left"
            triggerAfterDelay={0.5}
          />
        </>
      )}
    </div>
  )
}

export default TextHeroComponent
